let config = {};

config.baseURL = 'https://api.samudigitalrio.fs.rj.gov.br/api/v1/';
config.normalURL = 'https://api.samudigitalrio.fs.rj.gov.br/';
config.wsHost = 'websocket.app-samu.ares-saude.com.br';
config.database = 'CRSAMU_RJ_Rio';

export default config


// WEBPACK FOOTER //
// ./src/config/production.js